module.exports = __webpack_public_path__ + "static/img/Ace of Swords.dd74de5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ace of Swords.jpg
// module id = 1258
// module chunks = 0